import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../styles.module.scss';

interface RefreshButtonProps {
  onClick: () => void;
  translationKey?: string;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({
  onClick,
  translationKey = 'freightSearch.refresh',
}) => {
  const { t } = useTranslation();

  return (
    <button type="button" className={styles.refreshButton} onClick={onClick}>
      {t(translationKey)}
    </button>
  );
};

export default RefreshButton;
